import { action } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";
import type { OwsOptionsBase } from "owa-outlook-service-option-store";

export interface OutlookOptionsUpdatedActionMessage {
    mailboxInfo: MailboxInfo;
    options: OwsOptionsBase;
}

export const outlookOptionsUpdated: (mailboxInfo: MailboxInfo, options: OwsOptionsBase) => OutlookOptionsUpdatedActionMessage = action("outlookOptionsUpdated", (mailboxInfo: MailboxInfo, options: OwsOptionsBase): OutlookOptionsUpdatedActionMessage => ({
    mailboxInfo,
    options,
}));
